export default __webpack_public_path__ + "static/media/BadGateway.81729882.png";